// @steered AudibleSecurityContext 1.2 2026-09-21
/**
 * Plain-language description of what happens to a G2S2 change after a user
 * submits it for review. POCs using QuickLab are not expected to know G2S2,
 * CRs, or pipelines, so this copy answers the questions they actually ask:
 * "do I need to file anything?", "when does it go live?", "who tells me?".
 *
 * The submission-status card carries the live state of these steps; this copy
 * is the up-front explanation in Lumi's greeting.
 */

/** The four steps of the ORCA review/deployment SOP, in order. */
export const SUBMISSION_STEPS: readonly string[] = [
    'You create the records with Lumi and check them in the preview',
    'You submit to Slack — the ORCA team is notified automatically',
    'ORCA reviews the records you created',
    'ORCA pushes your change out in the normal daily deployment cycle',
];

/** Facts POCs have had to ask an engineer for; stated up front instead. */
export const SUBMISSION_EXPECTATIONS: readonly string[] = [
    "You don't need to file a Change Request or ticket yourself — submitting to Slack is the hand-off.",
    'Deployments run on a daily cadence. During Datapath restricted-day windows a deployment needs extra approval and can take longer.',
    'Progress and questions happen in the Slack thread your submission creates.',
];

/** Markdown block shown in Lumi's greeting, before the user has done anything. */
export const WHAT_HAPPENS_NEXT: string =
    '**What happens after you submit:**\n\n' +
    SUBMISSION_STEPS.map((step, i) => `${i + 1}. ${step}`).join('\n') +
    '\n\n' +
    SUBMISSION_EXPECTATIONS.map((line) => `• ${line}`).join('\n');
